/* eslint-disable camelcase */
import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation Module_multiUpdate($moduleData: [ModuleData]) {
    Module_multiUpdate(moduleData: $moduleData) {
      status
      value
    }
  }
`;

const moduleMultiUpdate = async moduleData => {
  // eslint-disable-next-line camelcase
  graphql(mutation, moduleData).then(({ Module_multiUpdate }) => ({
    Module_multiUpdate,
  }));
};

export default moduleMultiUpdate;
